import SelectWithoutSearch from "./SelectWithoutSearch";
export default SelectWithoutSearch;
